import { useMemo, useState } from 'react';
import { useGameFeature } from './useGameFeature';

export type useGlobalUserDataState = ReturnType<typeof useGlobalUserData>;
export const useGlobalUserData = () => {
    //not usually update user ac data
    const {
        isHedgeBettingEnabled,
        isAutoConfirmEnabled,
        isSideBetEnabled,
        isChatRoomOn,
    } = useGameFeature();
    const [gameNotSupportAutoConfirm, setNotSupportAutoConfirm] =
        useState<boolean>(false);
    const isAutoConfirm = useMemo(
        () => isAutoConfirmEnabled && !gameNotSupportAutoConfirm,
        [isAutoConfirmEnabled, gameNotSupportAutoConfirm]
    );
    return {
        isAutoConfirmEnabled,
        isHedgeBettingEnabled,
        isAutoConfirm,
        isSideBetEnabled,
        isChatRoomOn,
        setNotSupportAutoConfirm,
    };
};
